<!--Option Selector-->
<div class="lock-to-top" style="background-color: #ffffff; margin-bottom: 25px; margin-top: 0">
	<div class="date-body">
		<div class="selector-body">
			<div class="selector-item" style="display: flex">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						name="StartDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						name="EndDate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!--Data Table-->
<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 0px"
							(click)="onRefresh()"
						>
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintInfo()"
						>
							Print Information
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintLetter()"
						>
							Print Letter
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstMTACardUsage"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedMTACardUsage"
						dataKey="MTACardUsageID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--UseDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="UseDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--UseTimeDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="UseTimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--MTAFareboxDesc-->
								<th>
									<!-- <p-columnFilter field="MTAFareboxDesc" matchMode="equals" [showMenu]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown #filterMTAFareboxDesc [ngModel]="value" [options]="lstMTAFareboxDesc" (onChange)="filter($event.value)"
                                                placeholder="Any" [showClear]="true">
                                                <ng-template let-value pTemplate="item">
                                                    <span>{{value}}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter> -->

									<p-columnFilter
										id="MTAFareboxDesc"
										type="text"
										field="MTAFareboxDesc"
										matchMode="contains"
										[showMenu]="true"
									></p-columnFilter>
								</th>

								<!--MTADivisionDesc-->
								<th>
									<p-columnFilter id="MTADivisionDesc" field="MTADivisionDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterMTADivisionDesc
												[ngModel]="value"
												[options]="lstMTADivisionDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--MTARiderTypeDesc-->
								<th>
									<p-columnFilter id="MTARiderTypeDesc" field="MTARiderTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterMTARiderTypeDesc
												[ngModel]="value"
												[options]="lstMTARiderTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--MTARouteStationDesc-->
								<th>
									<p-columnFilter id="MTARouteStationDesc" field="MTARouteStationDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterMTARouteStationDesc
												[ngModel]="value"
												[options]="lstMTARouteStationDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--DailyAttendanceDesc-->
								<th>
									<p-columnFilter type="text" field="DailyAttendanceDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="UseDate">Date<p-sortIcon field="UseDate"></p-sortIcon></th>
								<th pSortableColumn="UseTime">Time<p-sortIcon field="UseTime"></p-sortIcon></th>
								<th pSortableColumn="MTAFareboxDesc">Farebox/Gate<p-sortIcon field="MTAFareboxDesc"></p-sortIcon></th>
								<th pSortableColumn="MTADivisionDesc">Division<p-sortIcon field="MTADivisionDesc"></p-sortIcon></th>
								<th pSortableColumn="MTARiderTypeDesc">Rider Type<p-sortIcon field="MTARiderTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="MTARouteStationDesc">Route/Station<p-sortIcon field="MTARouteStationDesc"></p-sortIcon></th>
								<th pSortableColumn="DailyAttendanceDesc">CAASS Daily Attendance<p-sortIcon field="DailyAttendanceDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-MTACardUsage>
							<tr [pSelectableRow]="MTACardUsage">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ MTACardUsage[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
